import { useMemo } from 'react'

import { useParams } from 'react-router'

import { findCurrentIndex } from 'components/page/PhotoViewer/function/findCurrentIndex'
import { PhotoViewerParams } from 'components/page/PhotoViewer/PhotoViewer.paths'

import { usePhotos } from './hooks/usePhotos'

export const useCurrentPhotoIndex = () => {
  const { photoId } = useParams<PhotoViewerParams>()
  const { photos } = usePhotos()

  return useMemo(() => findCurrentIndex(photos, photoId), [photoId, photos])
}
